"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Source: https://gist.github.com/gre/1650294
exports.EasingFunctions = {
    // no easing, no acceleration
    linear: function (t) { return t; },
    // accelerating from zero velocity
    easeInQuad: function (t) { return t * t; },
    // decelerating to zero velocity
    easeOutQuad: function (t) { return t * (2 - t); },
    // acceleration until halfway, then deceleration
    easeInOutQuad: function (t) { return (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t); },
    // accelerating from zero velocity
    easeInCubic: function (t) { return t * t * t; },
    // decelerating to zero velocity
    easeOutCubic: function (t) { return --t * t * t + 1; },
    // acceleration until halfway, then deceleration
    easeInOutCubic: function (t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    // accelerating from zero velocity
    easeInQuart: function (t) { return t * t * t * t; },
    // decelerating to zero velocity
    easeOutQuart: function (t) { return 1 - --t * t * t * t; },
    // acceleration until halfway, then deceleration
    easeInOutQuart: function (t) { return (t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t); },
    // accelerating from zero velocity
    easeInQuint: function (t) { return t * t * t * t * t; },
    // decelerating to zero velocity
    easeOutQuint: function (t) { return 1 + --t * t * t * t * t; },
    // acceleration until halfway, then deceleration
    easeInOutQuint: function (t) {
        return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    },
    easeInSin: function (t) { return 1 + Math.sin((Math.PI / 2) * t - Math.PI / 2); },
    easeOutSin: function (t) { return Math.sin((Math.PI / 2) * t); },
    easeInOutSin: function (t) { return (1 + Math.sin(Math.PI * t - Math.PI / 2)) / 2; }
};
exports.easeValue = function (value, type) {
    switch (type) {
        case 'linear':
            return exports.EasingFunctions.linear(value);
        case 'easeInQuad':
            return exports.EasingFunctions.easeInQuad(value);
        case 'easeOutQuad':
            return exports.EasingFunctions.easeOutQuad(value);
        case 'easeInOutQuad':
            return exports.EasingFunctions.easeInOutQuad(value);
        case 'easeInCubic':
            return exports.EasingFunctions.easeInCubic(value);
        case 'easeOutCubic':
            return exports.EasingFunctions.easeOutCubic(value);
        case 'easeInOutCubic':
            return exports.EasingFunctions.easeInOutCubic(value);
        case 'easeInQuart':
            return exports.EasingFunctions.easeInQuart(value);
        case 'easeOutQuart':
            return exports.EasingFunctions.easeOutQuart(value);
        case 'easeInOutQuart':
            return exports.EasingFunctions.easeInOutQuart(value);
        case 'easeInQuint':
            return exports.EasingFunctions.easeInQuint(value);
        case 'easeOutQuint':
            return exports.EasingFunctions.easeOutQuint(value);
        case 'easeInOutQuint':
            return exports.EasingFunctions.easeInOutQuint(value);
        case 'easeInSin':
            return exports.EasingFunctions.easeInSin(value);
        case 'easeOutSin':
            return exports.EasingFunctions.easeOutSin(value);
        case 'easeInOutSin':
            return exports.EasingFunctions.easeInOutSin(value);
        default:
            throw Error("Easing function \"" + type + "\" is not available.");
    }
};
//# sourceMappingURL=easing.js.map